import { useSelector } from "react-redux";

const useOrganizationId = () =>
  useSelector((state) => state.app?.organizations[0]?.organization_id.id);

export default useOrganizationId;
